var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"transfer-forecast","route":"/reports/billing-transfer-forecast","file-name":"repasse-previsto-e-pago.xlsx","period-label":"Período da competência","columns":_vm.columns,"default-days":180,"show-professional":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }